const LOADING = "loading"
const ERROR = "error"
const WAITING = "waiting"
const CHOICE = "choise"
const GAME = "game"
const BUSY = "busy"
const INTERVAL = "interval"
const START = "start"

export { LOADING, ERROR, WAITING, CHOICE, GAME, BUSY, START, INTERVAL } 